// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-j_gZ","advertDetailHeaderPrice__value":"c-j_ha","advertDetailHeaderPrice__label":"c-j_hb"};